// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"15":"afea0263","26":"2c21e7b8","83":"654119f3","90":"1aa680d3","170":"1d5e2660","271":"08161a97","453":"438d9e50","472":"69426bab","489":"51bfc089","563":"dac682f6","567":"a50d3c62","783":"25be1ac9","789":"8c2ef200","791":"d018082d","932":"df3fdceb"}[chunkId] + ".chunk.js";
};